module.exports = __webpack_public_path__ + "img/naging_biting_mr_weasley.e5d750e9.jpg";